import Close from '@mui/icons-material/Close'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import {
  Box,
  Chip,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import {
  SUPPORT_ACCESS_MATRIX,
  formatSupportRoleNames,
} from 'src/supportPortal/access/accessMatrix'

export default function SupportAccessInfoDrawer({ open, onClose }) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: { xs: '100vw', sm: 520 }, maxWidth: '100vw' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
            position: 'sticky',
            top: 0,
            bgcolor: 'background.paper',
            zIndex: 1,
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <InfoOutlined fontSize="small" />
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                Support Access Matrix
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Section and subsection access by role
              </Typography>
            </Box>
          </Stack>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>

        <Box sx={{ p: 2 }}>
          {SUPPORT_ACCESS_MATRIX.map((section) => (
            <Box key={section.section} sx={{ mb: 3 }}>
              <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                {section.section}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>Area</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Required Roles</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {section.rows.map((row) => (
                    <TableRow key={`${section.section}-${row.label}`}>
                      <TableCell sx={{ verticalAlign: 'top' }}>{row.label}</TableCell>
                      <TableCell sx={{ verticalAlign: 'top' }}>
                        <Chip
                          size="small"
                          label={formatSupportRoleNames(row.roles)}
                          sx={{
                            height: 'auto',
                            '& .MuiChip-label': {
                              display: 'block',
                              whiteSpace: 'normal',
                              py: 0.75,
                            },
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}
        </Box>
      </Box>
    </Drawer>
  )
}
